import { createAction } from '@ngrx/store';

export const toggleSidebar = createAction('[User] Toggle Menu');
export const closeSidebar = createAction('[User] Close Menu');
export const openSidebar = createAction('[User] Open Menu');